import L from "leaflet";
import moment from "moment";
import { IOcorrencia } from "../../../store/Models";
import { removeLastComma } from '../../../util/util';
import { redIcon, blueIcon, greenIcon, goldIcon } from "./MapIcons";
import './businessLogic.css';

export const transToSelect = (arrayList: Array<any>, valueField: string, labelField: string) => arrayList.map(a => {
    return { value: a[valueField], 'label': a[labelField] };
});

const especies:Array<string> = ["Chloris Polydacta", "Conyza spp.","Lolium multiflorum","Euphorbia heterophylla","Sorghum arundinaceum",
   "Amaranthus spp","Echinochloa crus-galli","Digitaria insularis","Bidens spp.","Eleusine indica"];

const ocorrenciaDetalhe = (o: IOcorrencia) => {

    let metadados = "";
    metadados += "Espécie      		      : " + o.species;
    metadados += "<br>";
    metadados += "Herbicidas resistentes  : " + (o.herbic_name? removeLastComma(o.herbic_name):'None');
    metadados += "<br>";
    metadados += "Mecanismo de resistência:" + (o.mechanism_name?removeLastComma(o.mechanism_name):'None');
    metadados += "<br>";

    return metadados;

}
//a partir dos marcadores, define a cor do cluster
const defineCorCluster = (markers: Array<any>):number => {
     //0 -azul, 1 - amarelo, 2 - vermelho
     let retorno: number = 0; 
    for (var i = 0; i < markers.length; i++) {
        let tipo: string = markers[i].options.icon?.options.iconUrl.toString();
        if (tipo.indexOf('red') !== -1){
            retorno = 2;
            break;
        }else{
            if (tipo.indexOf('gold') !== -1){
                retorno = 1;
            }
        }
    }
    return retorno;
}

export const removeLayers = (map: L.Map): any => {
    // remove as marcas antigas
    map && map.eachLayer(l => {
        // @ts-ignore
        (l._markerCluster || l._heat) && map.removeLayer(l);
        return l;
    });
}

const getIcon = (num_mecan:number):L.Icon => {
    let icon: L.Icon  = blueIcon;

    switch(num_mecan){
    case 0:
        icon = greenIcon;
    break;
    case 1:
        icon = goldIcon;
    break;
    case 2:
        icon = redIcon;
    break;
    case 3:
        icon = redIcon;
    break;
    default: icon = greenIcon;
    }
   return icon; 
}

export const createLayerOcorrencias = (map: L.Map, ocorrencias: Array<IOcorrencia>) => {

    if(!map || !ocorrencias ) return;

    removeLayers(map);

    let last: any = undefined;
    let markers: any = undefined;
    let groupLayers = L.layerGroup();

    // ordena as ocorrencias por estado + cidade
    ocorrencias.sort((a, b) => (a.cidade.nome) >= (b.cidade.nome) ? 1 : -1);

    ocorrencias.map(async o => {
        // quando houver a quebra da cidade cria um novo grupo de marcas
        if (o.cidade.nome !== last) {
            last = o.cidade.nome;
            markers = L.markerClusterGroup({
                spiderfyOnMaxZoom: true,
                showCoverageOnHover: false,
                zoomToBoundsOnClick: true,
                iconCreateFunction: function (cluster) { //customizacao do icone de grupo
                    var childCount = cluster.getChildCount();
                    let codigoCor = defineCorCluster(cluster.getAllChildMarkers());
                    return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', 
                     className:(codigoCor === 0? 'marker-cluster-simbol-default':
                     (codigoCor === 1? 'marker-cluster-simbol-atention': 'marker-cluster-simbol-danger')) , iconSize: new L.Point(15, 15) });
                    }
            });
            groupLayers.addLayer(markers);
        }
        let marker = L.marker(new L.LatLng(o.cidade.latitude, o.cidade.longitude), { icon: getIcon(o.num_mecan), title: o.cidade.nome }); // default

        marker.bindPopup(ocorrenciaDetalhe(o));
        markers.addLayer(marker);
        return undefined;
    });

    map.addLayer(groupLayers);

}

export const createLayerHeatOcorrencias = (map: L.Map, ocorrencias: Array<IOcorrencia>) => {

    if(!map || !ocorrencias ) return;

    removeLayers(map);

    let last: number = 0;
    let heatPoints:Array<any>= [];
    
    // ordena as ocorrencias por estado + cidade
    ocorrencias.sort((a, b) => (a.cidade.nome) >= (b.cidade.nome) ? 1 : -1);
    let counter = -1;
    ocorrencias.map(async o => {
        
        if (o.cidade.id !== last) { //nova cidade
            last = o.cidade.id;
            counter++;
            // @ts-ignore
            let point:Array<number>=[];
            point[0] = o.cidade.latitude;
            point[1] = o.cidade.longitude;
            point[2] =  0.1;
            heatPoints[counter] = point;
        }else{ //cidade atual 
            if (heatPoints[counter][2] < 1 ) //valor maximo da transparencia
                    heatPoints[counter][2] += 0.1;
        }
       
        return undefined;
    });
    var heat = L.heatLayer(heatPoints, { radius: 100,  gradient: {0.1: 'white', 0.2: 'yellow', 0.4: 'orange', 0.6: 'blue', 0.8: 'lime', 1: 'red'}});
    heat.addTo(map);
}


// gera uma tabela de total de ocorrencias por cidade e por tipo para gerar o grafico de barras
/*export const geraTotalOcorrenciasPorCidade = (ocorrencias: Array<IOcorrencia>): Array<any> => {
    const totalCidades: Array<any> = [];
    ocorrencias.map(o => {

        // total por cidade
        totalCidades[o.cidade.id] = {
            cidade: o.cidade,
            total: totalCidades[o.cidade.id] ? totalCidades[o.cidade.id].total + 1 : 1,
            tipos: totalCidades[o.cidade.id] ? totalCidades[o.cidade.id].tipos : {}
        }
        return o;

    });

    if(totalCidades.length === 0) return [];

    return Object.keys(totalCidades).map((key: any) => {
        const ret: any = { cidade: totalCidades[key].cidade.nome, total: totalCidades[key].total };
        Object.keys(totalCidades[key].tipos).map((k2: any) => {
            ret[k2] = totalCidades[key].tipos[k2];
            return k2;
        });
        return ret;
    });

}
*/
// gera uma tabela de total de ocorrencias por cidade e por tipo para gerar o grafico de barras


// gera uma tabela de total de ocorrencias por data para gerar o grafico de area
export const geraTotalOcorrenciasPorData = (ocorrencias: Array<IOcorrencia>, acumular: boolean = false): Array<any> => {
    const totalDatas: Array<any> = [];
    // acumulador de ocorrencias
    let vAcum = 0;
    // ordena as ocorrencias por data
    ocorrencias.sort((a,b) => moment(a.year) >= moment(b.year) ? 1 : -1);
    ocorrencias.map(o => {

        totalDatas[o.year] = {
            ano:  o.year,
            total: totalDatas[o.year] ? totalDatas[o.year].total + 1 : 1
        }

        if(acumular){
            vAcum++;
            totalDatas[o.year].total = vAcum;
        }
        return o;

    });

    const ret_datas = Object.keys(totalDatas).map((key: any) => {
        return { ano: totalDatas[key].ano, total: totalDatas[key].total };
    });

    ret_datas.sort((a,b) => a.ano >= b.ano ? 1 : -1);

    return ret_datas;

}

export const geraTotalOcorrenciasPorEspecie = (ocorrencias: Array<IOcorrencia>): Array<any> => {
    const totalEspecies: Array<any> = [];
    ocorrencias.map(o => { 
        let indice = (especies.indexOf(o.species) !== -1 ? especies.indexOf(o.species):0);
        // total por especie
        totalEspecies[indice] = {
            especie: o.species,
            total: totalEspecies[indice] ? totalEspecies[indice].total + 1 : 1
        }
        return o;

    });

    if(totalEspecies.length === 0) return [];
    const ret = Object.keys(totalEspecies).map((key: any) => {
        return { especie: totalEspecies[key].especie, total: totalEspecies[key].total };
    });
    return ret;
}

export const geraTotalOcorrenciasPorMecanismo = (ocorrencias: Array<IOcorrencia>): Array<any> => {
    const totalMecanismos: Array<any> = [
        {mecanismo: 'ACCase',total: 0}, //0
        {mecanismo: 'ALS',total: 0}, //1
        {mecanismo: 'EPSPS',total: 0}, //2
        {mecanismo: 'Growth Regulators',total: 0},//3
        {mecanismo: 'Photosynthesis',total: 0}, //4
        {mecanismo: 'Protox',total: 0}, //5
        {mecanismo: 'Glutamine',total: 0} //6
    ];

    ocorrencias.map(o => {       
        if (o.ac_case === 1) totalMecanismos[0].total++;
        if (o.als === 1) totalMecanismos[1].total++;
        if (o.epsps === 1) totalMecanismos[2].total++;
        if (o.reguladores_crescimento === 1) totalMecanismos[3].total++;
        if (o.fotossintese === 1) totalMecanismos[4].total++;
        if (o.protox === 1) totalMecanismos[5].total++;
        if (o.glutamina === 1) totalMecanismos[6].total++;
        return o;
    });

    if(totalMecanismos.length === 0) return [];
    const ret = Object.keys(totalMecanismos).map((key: any) => {
        return { mecanismo: totalMecanismos[key].mecanismo, total: totalMecanismos[key].total };
    });
    return ret;
}

export const geraTotalOcorrenciasPorResistencia = (ocorrencias: Array<IOcorrencia>): Array<any> => {
    const totalResistencias: Array<any> = [
        {resistencia: 'Simples',total: 0}, //0
        {resistencia: 'Múltipla',total: 0} //1
    ];

    ocorrencias.map(o => {       
        if (o.multiple_mechanism === 'Single_Resistant') totalResistencias[0].total++;
        if (o.multiple_mechanism === 'Multiplie_Resistance') totalResistencias[1].total++;
        return o;
    });

    if(totalResistencias.length === 0) return [];
    const ret = Object.keys(totalResistencias).map((key: any) => {
        return { resistencia: totalResistencias[key].resistencia, total: totalResistencias[key].total };
    });
    return ret;
}
